module.exports = __webpack_public_path__ + "static/karan-abd1f2d39ad5d872710ed70d71e75b36.png";